const menuTree = {
  state: {
    list: [] // 菜单数据
  },

  mutations: {
    SET_MENUS: (state, list) => {
      state.list = list
    }
  },

  actions: {
    // 获取菜单
    saveMenuList ({ commit }, list) {
      commit('SET_MENUS', list)
    }
  }
}
export default menuTree



// WEBPACK FOOTER //
// ./src/store/modules/menuTree.js